
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { UsageProgressBar } from "./UsageProgressBar";

type PlanUsageSectionProps = {
  companiesCount: number;
  companiesLimit: number;
  personResolutionsUsed: number;
  personResolutionsLimit: number;
  onUpgradeClick: () => void;
}

export const PlanUsageSection = ({
  companiesCount,
  companiesLimit,
  personResolutionsUsed,
  personResolutionsLimit,
  onUpgradeClick,
}: PlanUsageSectionProps) => {
  return (
    <Card className="p-4 bg-gray-50 border-gray-100 relative z-10">
      <h3 className="text-sm font-medium text-gray-900 mb-3">Plan Usage</h3>
      <div className="space-y-4">
        <UsageProgressBar 
          label="Company Resolutions"
          current={companiesCount}
          max={companiesLimit}
        />
        <UsageProgressBar 
          label="Person Resolutions"
          current={personResolutionsUsed}
          max={personResolutionsLimit}
        />
        <div className="space-y-2">
          <p className="text-[10px] text-gray-500 mt-1">Quotas reset in 30 days.</p>
          {/* Upgrade button commented out as per request */}
          {/* <Button
            className="w-full mt-2 bg-black hover:bg-black/90 text-sm font-medium"
            onClick={onUpgradeClick}
          >
            Upgrade
          </Button> */}
        </div>
      </div>
    </Card>
  );
};
